// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format11 } from '../../constants';

/** Guernsey */
const GG: PhoneNumberData = [
  44,
  'GG',
  10,
  format11,
  /^(?:7(?:(?:781|839)|911[17]))/,
];

export default GG;
